import { useQuery } from '@tanstack/react-query';
import { http, returnIfNotFoundError } from 'services/http';
import { ADDITIONAL_COSTS_GET_MANY } from 'api/query-keys';
import type { TAdditionalCostRes } from 'api/swagger';

interface IUseGetAdditionalCostsParams {
  orderId?: number;
  tripId?: number;
}

export const useGetAdditionalCosts = (params: IUseGetAdditionalCostsParams) => {
  const { orderId, tripId } = params;

  const qs = new URLSearchParams();
  const queryKey: string[] = [ADDITIONAL_COSTS_GET_MANY];

  if (orderId) {
    qs.set('filter[orderId]', String(orderId));
    queryKey.push(String(orderId));
  } else if (tripId) {
    qs.set('filter[tripId]', String(tripId));
    queryKey.push(String(tripId));
  } else {
    throw new Error('Either orderId or tripId must be provided');
  }

  return useQuery<TAdditionalCostRes[]>({
    queryKey,
    queryFn: async () => {
      try {
        const { data } = await http.get<TAdditionalCostRes[]>(`/v1/additional-costs?${qs.toString()}`);
        return data;
      } catch (error) {
        return returnIfNotFoundError<[]>(error, []);
      }
    },
    retry: false,
  });
};
